import styles from "./LocationSuggestionItemSkeleton.module.css";

export function LocationSuggestionItemSkeleton() {
    return (
        <div className={styles.skeleton}>
            <div className={styles.icon} />
            <div className={styles.content}>
                <div className={styles.primary} />
                <div className={styles.secondary} />
            </div>
        </div>
    );
}
